<template>
    <div class="cancel-message">
         <p class="modal-title">
            Do you have a minute to tell us why you're leaving?
        </p>
        <div class="controls">
            <base-submit-button
                class="btn btn-primary"
                @click="startOffboardingSurvey"
            >
                Sure! Ask me anything
            </base-submit-button>
            <span
                class="cancel-link"
                @click="$emit('finish')"
            >
                Skip this step
            </span>
        </div>
    </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
    methods: {
        ...mapActions(['setUserMeta']),

        /**
         * Starts offboarding survey
         */
        async startOffboardingSurvey() {
            await this.setUserMeta({ offboarding_started: Date.now() });
            this.$emit('change-step-next');
        },
    },
};
</script>
